import CTA from "./CTA";

export default CTA;
export {ctaTemplate} from "./CTA";